var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-absolute position-top-0 position-bottom-0 drag-handle",class:_vm.className,style:(_vm.cursorStyle),on:{"mousedown":_vm.startDrag,"dblclick":_vm.resetSize}})}
var staticRenderFns = []

export { render, staticRenderFns }